export class AttachScanToExistingMailComponentParams {
  lotGuid: string;
  courrierId: number;
  splitGuid: string;
  fileDescription: string;
  barCode: string;
  centreNumerisationId?: number;
}
